import { Component, h } from 'preact';
import * as appStyles from '../../assets/global.scss';
import { Properties, TravelType } from '../../common';
import { Row } from '../../common/Layout/Layout';
import { Actions, actions, BookingState, connectStore } from '../../store';
import { withStyles, WithStyles } from '../../style';
import TravelTypeRadio from './TravelTypeRadio/TravelTypeRadio';
import * as styles from './TravelTypeSelectorWithRadio.scss';

export interface TravelTypeSelectorProps extends Properties {}

interface StoreProps {
  travelType: TravelType;
}

type EffectiveProps = TravelTypeSelectorProps & StoreProps & WithStyles;

const mapStateToProps = ({ selection: { travelType } }: BookingState): StoreProps => ({ travelType });

@withStyles(styles, appStyles)
@connectStore({ mapStateToProps, actions })
export default class TravelTypeSelectorWithRadio extends Component<TravelTypeSelectorProps & Partial<Actions>> {
  selectTravelType = (travelType: TravelType) => this.props.setTravelType(travelType);

  render({ travelType, tx }: EffectiveProps) {
    return (
      <Row class={tx(this.props.class, 'space-between', 'font-body-1', 'horizontal')} wrapMe>
        <TravelTypeRadio
          class={tx('mr-medium-r')}
          value={TravelType.ROUND_TRIP}
          selected={travelType === TravelType.ROUND_TRIP}
          onCheck={this.selectTravelType}
        />
        <TravelTypeRadio
          value={TravelType.ONE_WAY}
          selected={travelType === TravelType.ONE_WAY}
          onCheck={this.selectTravelType}
        />
      </Row>
    );
  }
}
